<template>
  <SectionTemplate
    title="四种创作方式 让你轻松灵活上手"
    subTitle="4种创作方式"
    desc="有言支持从零创作、PPT导入、模版选择、AI生成脚本四种创作方式，全面适配不同内容类型与创作习惯，人人都能轻松上手。"
    class="four-ways-to-go-section"
    headerSpacing="40px"
  >
    <VideoCarousel :infos="infos" class="video-carousel-4ways" />
    <TrailBtn />
  </SectionTemplate>
</template>

<script lang="ts" setup>
import SectionTemplate from '@/design/widgets/landing-section/cn-template.vue';
import TrailBtn from '../../components/trail-btn.vue';
import VideoCarousel from '../../components/video-carousel.vue';

const infos: {
  title: string;
  url: string;
  poster: string;
  videoDesc: string;
}[] = [
  {
    title: '从零开始创作',
    url: getFeUrl('/youyan-platform/main/create-like-a-pro/1.webm'),
    poster: getFeUrl(
      '/youyan-platform/main/create-like-a-pro/ff-1.png?x-oss-process=image/format,webp',
    ),

    videoDesc: '使用有言可以从零开始创作AI数字人视频',
  },
  {
    title: '从模版开始创作',
    url: getFeUrl('/youyan-platform/main/create-like-a-pro/2.webm'),
    poster: getFeUrl(
      '/youyan-platform/main/create-like-a-pro/ff-2.png?x-oss-process=image/format,webp',
    ),
    videoDesc: '有言提供数千个AI数字人模板帮助用户创作视频',
  },
  {
    title: '从AI脚本创作',
    url: getFeUrl('/youyan-platform/main/create-like-a-pro/3.webm'),
    poster: getFeUrl(
      '/youyan-platform/main/create-like-a-pro/ff-3.png?x-oss-process=image/format,webp',
    ),
    videoDesc: '可以使用有言的AI视频脚本助手帮助用户创作视频',
  },
  {
    title: '从PPT开始创作',
    url: getFeUrl('/youyan-platform/main/create-like-a-pro/4.webm'),
    poster: getFeUrl(
      '/youyan-platform/main/create-like-a-pro/ff-4.png?x-oss-process=image/format,webp',
    ),
    videoDesc: '用户可以在有言上传PPT或使用官方PPT创作3D数字人视频',
  },
];
</script>

<style lang="scss">
.four-ways-to-go-section {
  position: relative;

  .section-header {
    .sub-title {
      background-color: var(--x-back-5) !important;
    }
  }

  @media (min-width: $media-pc) {
    .video-carousel-4ways {
      margin-bottom: 40px;

      .video-carousel-tab-item {
        width: 146px;
        border-radius: 22px;
        height: 44px;

        .title {
          font-size: 14px;
          color: var(--x-text-3);
        }
      }
    }
  }

  @media (max-width: $media-mobile) {
    &.section-template {
      padding-left: 0;
      padding-right: 0;
    }

    .section-header {
      margin-bottom: 24px !important;

      .sub-title,
      .title,
      .desc {
        padding-left: 20px;
        padding-right: 20px;
      }

      .title {
        max-width: 248px;
        margin: 0 auto;
        text-align: center;
      }

      .desc {
        width: 100%;
        max-width: none;
        box-sizing: border-box;
        align-self: stretch;
      }
    }

    .video-carousel-4ways {
      margin-bottom: 0;
      width: 100%;
    }

    .trail-btn {
      margin-top: 24px !important;
      width: 335px !important;
      max-width: 100% !important;
      height: 44px !important;
      min-height: 44px !important;
      box-sizing: border-box !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      gap: 6px !important;
      font-size: 14px !important;
      font-weight: 400 !important;
    }
  }
}
</style>
